interface StatusBadgeProps {
    status: 'confirmed' | 'pending' | 'cancelled' | 'pending_approval' | 'pending_payment'
    className?: string
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
    const statusConfig = {
        confirmed: {
            label: 'Confirmado',
            className: 'bg-green-100 text-green-800 border-green-200'
        },
        pending: {
            label: 'Pendente',
            className: 'bg-yellow-100 text-yellow-800 border-yellow-200'
        },
        cancelled: {
            label: 'Cancelado',
            className: 'bg-red-100 text-red-800 border-red-200'
        },
        pending_approval: {
            label: 'Aguardando Aprovação',
            className: 'bg-blue-100 text-blue-800 border-blue-200'
        },
        pending_payment: {
            label: 'Aguardando Pagamento',
            className: 'bg-purple-100 text-purple-800 border-purple-200'
        },
        DRAFT: {
            label: 'Rascunho',
            className: 'bg-gray-100 text-gray-800 border-gray-200'
        },
        COMPLETED: {
            label: 'Concluído',
            className: 'bg-blue-100 text-blue-800 border-blue-200'
        },
        IN_PROGRESS: {
            label: 'Em Andamento',
            className: 'bg-indigo-100 text-indigo-800 border-indigo-200'
        }
    }

    // Normalized lookup (case-insensitive safety)
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : ''

    // Map to config keys
    const keyMap: Record<string, keyof typeof statusConfig> = {
        confirmed: 'confirmed',
        pending: 'pending',
        cancelled: 'cancelled',
        canceled: 'cancelled', // Handle US spelling
        pending_approval: 'pending_approval',
        pending_payment: 'pending_payment',
        draft: 'DRAFT',
        completed: 'COMPLETED',
        in_progress: 'IN_PROGRESS'
    }

    const configKey = keyMap[normalizedStatus]
    const config = configKey ? statusConfig[configKey] : {
        label: status || 'Desconhecido',
        className: 'bg-gray-100 text-gray-500 border-gray-200'
    }

    return (
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider border ${config.className} ${className}`}>
            {config.label}
        </span>
    )
}
